/**
 * 高棉文文案。Key 语义化且稳定，**禁止用中文原文当 Key**。
 *
 * 界面上出现的每一个字都必须来自这里。服务端返回的 message 是中文，只进日志。
 */
export const km = {
  // 通用
  loading: 'កំពុងផ្ទុក…',
  retry: 'ព្យាយាមម្តងទៀត',
  // 视频设置面板最下面的「取消」，和 App 的 cancel 同一个译文
  cancel: 'បោះបង់',
  episodeLabel: 'ភាគ',
  // 视频下方的选集条，照红果「选集 · 已完结 · 全N集」/「选集 · 更新至N集」。{n} 手工替换。
  // 和 App 的 episode_band_done / episode_band_ongoing 同一套译文
  episodeBandDone: 'ជ្រើសភាគ · ចប់ · សរុប {n} ភាគ',
  episodeBandOngoing: 'ជ្រើសភាគ · ដល់ភាគ {n}',
  // 选集面板剧名下面那行：完结了写「全N集」，没完结写「更新至N集」
  episodeTotal: 'សរុប {n} ភាគ',
  episodeUpdatedTo: 'ដល់ភាគ {n}',
  // 简介两行截断时末尾的「展开」
  expand: 'បន្ថែម',
  // 自动播放被拦下来时在静音播，这句请用户点一下开声音
  unmute: 'ចុចដើម្បីបើកសំឡេង',
  free: 'ឥតគិតថ្លៃ',
  // 选集格子里看过的那一集的无障碍说明
  watched: 'បានមើលហើយ',

  // 清晰度
  quality: {
    title: 'គុណភាពរូបភាព',
    auto: 'ស្វ័យប្រវត្តិ',
    // 卡顿时的建议。语气和主流平台一致：是建议，不是报错——
    // 网络不好不是用户做错了什么。
    stallTitle: 'បណ្តាញយឺត',
    stallBody: 'ប្តូរទៅគុណភាពទាបជាង ដើម្បីមើលបានរាបរយ',
    stallAction: 'ប្តូរ',
    stallDismiss: 'កុំអើពើ',
    // 切档不是立刻见效的：要等缓冲里的旧片段放完、新档的片段下回来。
    // 这几秒里没有反馈，人会以为点了没用，于是反复点。
    switched: 'បានប្តូរទៅ {q}',
    // 档位的单位后缀。{n} 是短边像素数（360/540/720...），手工替换，不接插值引擎。
    unit: '{n}P',
  },

  // 倍速
  rate: {
    title: 'ល្បឿនចាក់',
    // 倍速的单位后缀。{n} 是已经格式化好的数字（0.75/1.0/1.25...）。
    unit: '{n}x',
    // 长按两侧顶速时选集条位置那条黑条。{n} 是不带单位的倍速数字（2.0），数字着强调色。
    boosting: 'កំពុងចាក់លឿន {n}x',
    // 视频底部的小胶囊，跟着手势一步步换。和红果一样：上滑锁、松手才生效；锁定后再长按下滑退出。
    lockHint: 'អូសឡើងដើម្បីចាក់សោល្បឿន',
    lockRelease: 'លែងដៃដើម្បីចាក់សោល្បឿន',
    // 松手后的结论，同一个胶囊里停 3 秒。{n} 同上
    locked: 'បានចាក់សោល្បឿន {n}x',
    unlockHint: 'អូសចុះដើម្បីចេញពីល្បឿនលឿន',
    unlockRelease: 'លែងដៃដើម្បីចេញពីល្បឿនលឿន',
    restored: 'បានត្រឡប់ទៅល្បឿន {n}x',
  },

  // 清屏播放：藏掉画面上所有按钮和文字，只看片子
  cleanScreen: {
    enter: 'មើលអេក្រង់ស្អាត',
    exit: 'ចេញពីអេក្រង់ស្អាត',
  },

  // 门禁引导
  gate: {
    needChannelTitle: 'ចូលរួមឆានែលដើម្បីមើលបន្ត',
    needChannelBody: 'ភាគបន្ទាប់អាចមើលបានបន្ទាប់ពីចូលរួមឆានែល',
    needChannelAction: 'ចូលរួមឆានែល',
    needBotTitle: 'បើកការជូនដំណឹង',
    needBotBody: 'បើកការជូនដំណឹងដើម្បីមើលបន្ត និងដឹងពេលមានភាគថ្មី',
    needBotAction: 'បើកការជូនដំណឹង',
    needAppTitle: 'មើលក្នុងកម្មវិធី',
    needAppBody: 'ភាគពេញលេញអាចមើលបានក្នុងកម្មវិធី',
    needAppAction: 'ទាញយកកម្មវិធី',
  },

  // 错误码 → 文案。新增错误码时这里必须同步，否则类型检查会报。
  error: {
    bad_request: 'សំណើមិនត្រឹមត្រូវ',
    invalid_credential: 'សូមបើកម្តងទៀតពីក្នុង Telegram',
    invalid_token: 'សូមបើកម្តងទៀត',
    unsupported_provider: 'មិនស្គាល់ប្រភពគណនី',
    not_found: 'រឿងនេះមិនមានទេ',
    no_media: 'ភាគនេះមិនទាន់មាន',
    not_configured: 'ប្រព័ន្ធកំពុងរៀបចំ',
    forbidden: 'អ្នកមិនមានសិទ្ធិចូលមើលទេ',
    conflict: 'មានរឿងនេះរួចហើយ',
    rate_limited: 'សូមរង់ចាំមួយភ្លែត ហើយព្យាយាមម្តងទៀត',
    internal: 'មានបញ្ហា សូមព្យាយាមម្តងទៀត',
    unknown: 'មានបញ្ហា សូមព្យាយាមម្តងទៀត',
    outsideTelegram: 'សូមបើកតំណនេះក្នុង Telegram',
  },
} as const
